import script from "./payment-type-echarts.vue?vue&type=script&setup=true&lang=js"
export * from "./payment-type-echarts.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__